import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
// Batch 4.1 (#82 MG-008, #83 MG-009, #84 AD-008, #85 AD-009): the bracket system is disabled.
// This screen serves BOTH contest modes - the bracket view and the no-bracket player list - so it
// is not unrouted; the bracket half is commented out and the no-bracket half is left working.
// The bracket-only imports were: BracketUpdate, TournamentBarcketId, TournamentUpdateTeamDate,
// TournamentUpdateTeamScore.
import { GetTournamentTeamMatch, TournamentUpdatePlayerMatchDate, TournamentUpdatePlayerMatchScore } from "../../redux/auth-reducer/auth-service";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import { toast } from "react-toastify";
import * as icons from 'react-bootstrap-icons';
import { Button, Card, Col, Form, ListGroup, Modal, Row, Tab, Tabs } from "react-bootstrap";
import { DatePicker, Loader } from "rsuite";
import dayjs from "dayjs";
import { Footer } from "../../Footer";
import { readApiMessage } from "../../utils/helper/helper";
import { isResultsPublished, isScored, publishBlocker, publishRequest, rankTeams, scoreBlocker, scoreRequest } from "../../utils/helper/contestResults";

// #213: a score is a whole number, 0 or more - the server's rule and its sentence. The field
// takes any typing; a negative, decimal or empty value shows this and is never sent.
const SCORE_INVALID_MESSAGE = "Score cannot be less than zero or negative or decimal.";
const isValidScore = (value) => /^\d+$/.test(String(value ?? "").trim());

export const SetupBracket = (props) => {
  // Batch 4.1: roundData stays declared but is never populated again - Bracketfn is commented
  // out below. It remains the mode discriminator at the two ternaries in the JSX, so with a
  // permanently empty array both always take the no-bracket branch.
  const [roundData, setRoundData] = useState([]);
  const [dataSide, setDataSide] = useState(false);
  // const [editMode, setEditMode] = useState(false);
  // const [editModeByIndex, setEditModeByIndex] = useState("");
  // const [firstMatchIdItem, setFirstMatchIdItem] = useState();
  // const [scondMtachId, setScondMtachId] = useState();
  // const [secondsId, setSecondsId] = useState();
  const [count, setCount] = useState(0);
  // const [scoreData, setScoreData] = useState([])
  // const [dataListItem, setDataListItem] = useState([]);
  // const [show, setShow] = useState(false);
  // const [isChecked, setIsChecked] = useState(false);
  // const [matchIdScore, setMatchIdScore] = useState([]);
  // const [startMatch, setStartMatch] = useState()
  const { id } = useParams();
  const [dateValid, setDateValid] = useState(true);
  // const [tournamentIdScore, setTournamentIdScore] = useState()
  // const [dataId, setDataId] = useState()
  const [teamData, setTeamData] = useState([])
  // #216: the first load shows a loader, and a failed load shows its message instead of a blank page.
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  // const [showDate, setShowDate] = useState(false);
  const [noBracketshow, setNoBracketshow] = useState(false);
  // const [roundMatchData, setRoundMatchData] = useState(null);
  const [selectedListItem, setSelectedListItem] = useState(null);
  const [startNoBracketMatch, setStartNoBracketMatch] = useState(null)
  const [scoreNoBracket, setScoreNoBracket] = useState("")
  const [scoreInvalid, setScoreInvalid] = useState(false)
  const [noBracketshowDate, setNoBracketshowDate] = useState(false)
  const [validated, setValidated] = useState(false);
  const [dateUpdate, setDateUpdate] = useState();
  // #223: the rows the Publish Results confirmation was opened with (read again on opening), or
  // null while it is closed; and whether the publish request is on its way.
  const [publishRows, setPublishRows] = useState(null);
  const [publishing, setPublishing] = useState(false);
  // const [dataList, setDataList] = useState({
  //   leftTeamScore: null,
  //   rightTeamScore: null,
  //
  // });
  // useEffect(() => {
  //   roundData?.map((item) => {
  //     // {item?.tournamentId};
  //     setTournamentIdScore(item?.tournamentId);
  //
  //     setMatchIdScore(item?.matchId)
  //
  //   })
  // })

  const handleNoBracketDateUpdate = async (tournamentId) => {


    if (!dateUpdate) {
      setDateValid(false);
      return; // Exit if no date is selected
    }




    const data =
    {
      "tournamentId": tournamentId,
      "matchStartDate": dateUpdate
    }
    await TournamentUpdatePlayerMatchDate(data).then((res) => {
      if (res?.data?.status === true) {
        setDateValid(true);
        toast.success(res?.data?.message);
        setDateValid(true);
        setCount(count + 1);
        setNoBracketshowDate(false)
      }
      else {
        setDateValid(true);
        toast.error(res?.data?.message);
      }
    })
  }
  const handelNoBracketDate = (e) => {
    setDateValid(true);
    // setStartNoBracketMatch(e); // Set the selected date
    // Update the state with the new date
    setDateUpdate(e); // Assuming this is for another state update

  }



  // #223: a score save never completes the contest - only Publish Results below does. The
  // "Match Completed" checkbox this dialog had showed for the last team only, and its state
  // outlived the dialog, so a later save of another team could complete the contest unseen.
  const handleNoBracketScorecheck = async () => {
    setValidated(true)

    if (!isValidScore(scoreNoBracket)) {
      setScoreInvalid(true);
      toast.error(SCORE_INVALID_MESSAGE);
      return;
    }

    // #269: no match date yet - say so here; the server's own sentence for it is ungrammatical.
    const blocker = scoreBlocker(selectedListItem);
    if (blocker) {
      toast.error(blocker);
      return;
    }

    const data = scoreRequest(selectedListItem, Number(String(scoreNoBracket).trim()));


    await TournamentUpdatePlayerMatchScore(data).then(async (res) => {

      if (res?.data?.status === true) {

        toast.success(res?.data?.message);
        setCount(count + 1);
        setNoBracketshow(false);
        // Fetch updated score data after successful update
      } else {
        // #213: a 400 (ValidationProblemDetails) or a bodiless failure has no data.message.
        toast.error(readApiMessage(res));
      }
    });
  };
  const handelNoBracketScoreUpdate = (e) => {
    const newScore = e.target.value;

    setScoreNoBracket(newScore);
    setScoreInvalid(!isValidScore(newScore));
  };
  const handleNoBracketClose = () => {
    setNoBracketshow(false)
    setNoBracketshowDate(false)
  };

  // #223: Publish Results reads the rows again first, so the standings it shows - and the score
  // it sends back - are the server's, not what this page loaded.
  const handlePublishOpen = async () => {
    const res = await GetTournamentTeamMatch(id);
    if (!Array.isArray(res?.data)) {
      toast.error(readApiMessage(res, "The contest results could not be loaded. Please try again."));
      return;
    }

    setTeamData(res.data);
    const blocker = publishBlocker(res.data, Date.now());
    if (blocker) {
      toast.error(blocker);
      return;
    }

    setPublishRows(res.data);
  };

  const handlePublishClose = () => {
    if (!publishing) setPublishRows(null);
  };

  const handlePublishConfirm = async () => {
    if (publishing || !publishRows) return;

    setPublishing(true);
    const res = await TournamentUpdatePlayerMatchScore(publishRequest(publishRows));
    setPublishing(false);

    if (res?.data?.status === true) {
      toast.success("The results have been published.");
      setPublishRows(null);
      setCount((c) => c + 1);
    } else {
      toast.error(readApiMessage(res));
    }
  };
  // const handelDate = (e) => {
  //
  //   // setDateUpdate(e)
  //   setStartMatch(e)
  //
  // }


  useEffect(() => {
    const fetchTournamentData = async () => {
      if (roundData?.length === 0) {
        const res = await GetTournamentTeamMatch(id);
        // #216: the endpoint returns a plain array, one row per team from the contest's first
        // save, so it is never empty for a real contest - whether anything has sold is each row's
        // hasPlayers. Anything else is a failed load: no reply, or the 404 "Contest not found."
        // for a contest that does not exist or is not the caller's. teamData stays an array
        // either way, so the teamData[0] reads below cannot throw.
        if (Array.isArray(res?.data)) {
          setTeamData(res.data);
          setLoadError("");
        } else {
          setTeamData([]);
          setLoadError(readApiMessage(res, "The contest results could not be loaded. Please try again."));
        }
        setLoading(false);
      }
    };

    fetchTournamentData();
  }, [count]);


  const scoreNoBracketModel = (listItem) => {
    setSelectedListItem(listItem)
    /************** */
    const dateCurrent = dayjs(listItem?.matchStartDate).format("MM/DD/YYYY") === "01/01/1901 T00:00:00"
      ? dayjs().format("MM/DD/YYYY T00:00:00")
      : dayjs(listItem?.matchStartDate).format("MM/DD/YYYY T00:00:00");
    setStartNoBracketMatch(dateCurrent);


    // #223: null until the team is scored.
    setScoreNoBracket(listItem.playerScore ?? "")
    setScoreInvalid(false)
    setNoBracketshow(true);

  };




  // Batch 4.1 (#83/#85): bracket match-date and match-score updates. The endpoints behind
  // TournamentUpdateTeamDate / TournamentUpdateTeamScore / TournamentBarcketId are gone.
  // const handleDateUpdate = async () => {
  //   const data =
  //   {
  //     "matchId": dataList?.matchId,
  //     "tournamentId": tournamentIdScore,
  //     "matchStartDate": startMatch
  //   }
  //   await TournamentUpdateTeamDate(data).then((res) => {
  //     if (res?.status == true) {
  //       setDateValid(false);
  //       setStartMatch('')
  //       // window?.location.reload();
  //       toast.success(res?.message);
  //       setCount(count + 1);
  //       setShowDate(false);
  //     }
  //     else {
  //       toast.error(res?.message);
  //     }
  //   })
  // }
  // const handleClose = () => {
  //   setShow(false)
  //   setShowDate(false)
  //   setIsChecked(false)
  // };
  // const Bracketfn = async () => {
  //   await TournamentBarcketId(id).then((res) => {
  //     setRoundData(res);
  //   });
  // };

  // const handleCheckboxChange = (event) => {
  //   setIsChecked(event.target.checked);
  // };


  // const handleScorecheck = async () => {
  //
  //   const leftScore = Number(dataList?.leftTeamScore);
  //   const rightScore = Number(dataList?.rightTeamScore);
  //
  //   // Validate that scores are whole numbers
  //   if (!Number.isInteger(leftScore) || !Number.isInteger(rightScore)) {
  //     toast.error("Scores should not be decimal number.");
  //     return; // Exit the function if validation fails
  //   }
  //
  //   const data = {
  //     "matchId": dataList?.matchId,
  //     "tournamentId": tournamentIdScore,
  //     "leftTeamScore": Number(dataList?.leftTeamScore),
  //     "rightTeamScore": Number(dataList?.rightTeamScore),
  //     "isCompleted": isChecked
  //   };
  //
  //   await TournamentUpdateTeamScore(data).then(async (res) => {
  //     if (res?.status === true) {
  //
  //       toast.success(res?.message);
  //       setCount(count + 1);
  //       setShow(false);
  //       setIsChecked(false)
  //
  //       // Fetch updated score data after successful update
  //     } else {
  //       toast.error(res?.message);
  //
  //     }
  //   });
  // };

  // useEffect(() => {
  //   Bracketfn();
  // }, [count]);
  // useEffect(() => {
  //   const BracketfnGet = async () => {
  //     await TournamentBarcketId(id).then((res) => {
  //
  //       setScoreData(res)
  //       setDataListItem(res)
  //     })
  //   }
  //   BracketfnGet()
  // }, [count]);



  function sidebarfun() {
    setDataSide(!dataSide);
  }
  // Batch 4.1 (#82/#84): bracket team shuffling (assigning teams to bracket slots).
  // const handleEditClickTeam = (ind, id) => {
  //   const selectedMatch = roundData.find(itemList => itemList.matchId === id);
  //   if (selectedMatch) {
  //     setFirstMatchIdItem(id)
  //     setEditModeByIndex(ind);
  //     // setEditMode(true);
  //     setRoundMatchData(selectedMatch); // Assuming you have a state to hold matchDetails
  //   }
  // }





  // const closebtn = () => {
  //
  //   setEditModeByIndex(null); // Reset editModeByIndex to null
  //   setRoundMatchData(null);
  // }

  // const handelScoreUpdate = (e) => {
  //
  //   setDataList({
  //     ...dataList,
  //     [e.target.name]: e.target.value
  //   })
  // }

  // const handelOnChange = (e) => {
  //   const [value, array] = e.target.value.split(",");
  //   setSecondsId(array);
  //   setScondMtachId(value);
  //
  // }

  // const handleSaveClick = async () => {
  //   const Updatedata =
  //   {
  //     "tournamentId": Number(id),
  //     "firstTeamMatchId": firstMatchIdItem,
  //     "firstTeamId": editModeByIndex,
  //     "secondTeamMatchId": Number(scondMtachId),
  //     "secondTeamId": Number(secondsId),
  //   }
  //   await BracketUpdate(Updatedata).then((res) => {
  //     if (res?.status == true) {
  //       Bracketfn();
  //       toast.success(res?.message);
  //       setCount(count + 1)
  //       setEditModeByIndex(null);
  //     }
  //     else {
  //       toast.error(res?.message);
  //     }
  //   })
  //   setEditMode(false);
  // }



  // const handleShow = (list) => {
  //
  //
  //
  //
  //   setDataList(list)
  //   // setCheckList(true);
  //   setShow(true);
  //
  // }



  // Batch 4.1 (#82 MG-008, #83 MG-009, #84 AD-008, #85 AD-009): bracket rendering and
  // geometry. constructPlayers / populateTree / connectLines / drawConnectorsBetweenMatches
  // and the connector-drawing effect exist only to lay out the single-elimination tree,
  // which is no longer reachable. Block-commented rather than deleted - restore together
  // with the bracket JSX at the bottom of this file. Note that `data` was also read by the
  // footer className near the end of the render; that reference is commented out there too.
  /*
  function constructPlayers(roundData) {
    const players = {};

    const sortedLevels = [
      ...new Set(roundData.map(({ matchLevel }) => matchLevel)),
    ].sort((a, b) => b - a);

    const levelToRound = {};
    sortedLevels.forEach((level, index) => {
      levelToRound[level] = `round${index + 1}`;
    });

    roundData.forEach(
      ({
        matchLevel,
        leftTeamId,
        rightTeamId,
        leftTeamName,
        rightTeamName,
        // matchId,


      }) => {
        const roundKey = levelToRound[matchLevel];

        if (!players[roundKey]) {
          players[roundKey] = [];
        }

        players[roundKey].push([
          leftTeamId !== 0 ? leftTeamId : "tbd",
          rightTeamId !== 0 ? rightTeamId : "tbd",
          // leftTeamName|| (leftTeamId !== 0 ? leftTeamId : "tbd"),
          // rightTeamName || (rightTeamId !== 0 ? rightTeamId : "tbd"),
          // matchId || (matchId),


        ]);
      }
    );




    return players;
  }


  const playersData = constructPlayers(roundData);

  // function populateTree(obj) {
  //   const newObj = JSON.parse(JSON.stringify(obj));

  //   const roundNumbers = Object.keys(newObj)
  //     .filter((key) => key.startsWith("round"))
  //     .map((key) => parseInt(key.replace(/[^\d]/g, ""), 10))
  //     .filter((num) => !isNaN(num));

  //   const maxRound = Math.max(...roundNumbers);
  //   let pointer = maxRound;

  //   while (pointer > 1) {
  //     const currRoundKey = `round${pointer}`;
  //     const prevRoundKey = `round${pointer - 1}`;

  //     if (!newObj[currRoundKey] || !Array.isArray(newObj[currRoundKey])) {
  //       pointer--;
  //       continue;
  //     }

  //     const currRound = newObj[currRoundKey].reduce((acc, item) => {
  //       return Array.isArray(item) ? acc.concat(item) : acc;
  //     }, []);

  //     if (!newObj[prevRoundKey] || !Array.isArray(newObj[prevRoundKey])) {
  //       newObj[prevRoundKey] = [];
  //     }

  //     for (let i = 0; i < currRound.length; i++) {
  //       if (currRound[i] !== "tbd") {
  //         newObj[prevRoundKey].splice(i, 0, [null, null]);
  //       }
  //     }
  //     pointer--;
  //   }

  //   return newObj;
  // }

  // function connectLines(obj, newLines) {
  //   const round = Math.max(
  //     ...Object.keys(obj).map((key) => parseInt(key.replace(/[A-Za-z$-]/g, "")))
  //   );

  //   let pointer = round;

  //   while (pointer !== 1) {
  //     const currRound = obj[`round${pointer}`];

  //     for (let i = 0; i < currRound.length; i++) {
  //       if (currRound[i][0] === "tbd") {
  //         drawConnectorsBetweenMatches(
  //           `.round${pointer - 1}match${i * 2 + 1}`,
  //           `.round${pointer}match${i + 1}`,
  //           newLines
  //         );
  //       }
  //       if (currRound[i][1] === "tbd") {
  //         drawConnectorsBetweenMatches(
  //           `.round${pointer - 1}match${i * 2 + 2}`,
  //           `.round${pointer}match${i + 1}`,
  //           newLines
  //         );
  //       }
  //     }
  //     pointer--;
  //   }
  // }


  function populateTree(obj) {
    const newObj = JSON.parse(JSON.stringify(obj));

    const roundNumbers = Object.keys(newObj)
      .filter((key) => key.startsWith("round"))
      .map((key) => parseInt(key.replace(/[^\d]/g, ""), 10))
      .filter((num) => !isNaN(num));

    const maxRound = Math.max(...roundNumbers);
    let pointer = maxRound;

    while (pointer > 1) {
      const currRoundKey = `round${pointer}`;
      const prevRoundKey = `round${pointer - 1}`;

      if (!newObj[currRoundKey] || !Array.isArray(newObj[currRoundKey])) {
        pointer--;
        continue;
      }

      const currRound = newObj[currRoundKey].reduce((acc, item) => {
        return Array.isArray(item) ? acc.concat(item) : acc;
      }, []);

      if (!newObj[prevRoundKey] || !Array.isArray(newObj[prevRoundKey])) {
        newObj[prevRoundKey] = [];
      }

      for (let i = 0; i < currRound.length; i++) {
        if (
          currRound[i] !== "tbd" &&
          !newObj[prevRoundKey].some((pair) => pair.includes(currRound[i]))
        ) {
          newObj[prevRoundKey].splice(i, 0, [null, null]);
        }
      }
      pointer--;
    }

    return newObj;
  }

  function connectLines(obj, newLines) {
    const round = Math.max(
      ...Object.keys(obj).map((key) => parseInt(key.replace(/[A-Za-z$-]/g, "")))
    );

    let pointer = round;

    while (pointer !== 1) {
      const currRound = obj[`round${pointer}`];
      const prevRound = obj[`round${pointer - 1}`];

      if (!currRound || !prevRound) {
        pointer--;
        continue;
      }

      for (let i = 0; i < currRound.length; i++) {
        const [teamA, teamB] = currRound[i];

        let teamIndexA = prevRound.findIndex((pair) => pair.includes(teamA));
        let teamIndexB = prevRound.findIndex((pair) => pair.includes(teamB));

        if (teamA !== "tbd" && teamIndexA !== -1) {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${teamIndexA + 1}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }

        if (teamB !== "tbd" && teamIndexB !== -1) {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${teamIndexB + 1}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }

        if (teamA === "tbd") {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${i * 2 + 1}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }
        if (teamB === "tbd") {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${i * 2 + 2}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }
      }
      pointer--;
    }
  }

  const newPlayersData = populateTree(playersData);
  const data = newPlayersData;
  const [lines, setLines] = useState([]);

  function getName(player) {
    if (!player) return "Player";
    if (player === "bye") return "Bye";
    if (player === "tbd") return "TBD";
    return player;
  }

  const drawConnectorsBetweenMatches = (
    match1Selector,
    match2Selector,
    newLines
  ) => {
    const playoffTable = document.querySelector(".playoff-table");
    if (!playoffTable) return;
    const { scrollLeft, offsetTop } = playoffTable;
    const { left: playoffTableLeft } = playoffTable.getBoundingClientRect();

    const match1Elem = document.getElementById(match1Selector);
    const match2Elem = document.getElementById(match2Selector);

    if (!match1Elem || !match2Elem) return;

    const match1Rect = match1Elem.getBoundingClientRect();
    const match2Rect = match2Elem.getBoundingClientRect();

    let midPointX =
      (match1Rect.right + match2Rect.left) / 2 + scrollLeft - playoffTableLeft;

    newLines.push({
      x1: midPointX,
      y1: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
      x2: midPointX,
      y2: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop,
    });
    newLines.push({
      x1: match1Rect.right + scrollLeft - 20 - playoffTableLeft,
      y1: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
      x2: midPointX,
      y2: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
    });
    newLines.push({
      x1: match2Rect.left + scrollLeft + 20 - playoffTableLeft,
      y1: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop,
      x2: midPointX,
      y2: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop,
    });
  };

  useEffect(() => {
    if (!data || Object.keys(data).length === 0) return;

    const playoffTable = document.querySelector(".playoff-table");
    const linesOverlay = document.querySelector(".lines-overlay");
    if (!playoffTable || !linesOverlay) return;

    const calculatePositions = () => {
      let newLines = [];
      connectLines(data, newLines);

      // Only update state if newLines is different from the current state
      if (JSON.stringify(newLines) !== JSON.stringify(lines)) {
        setLines(newLines);
      }
    };

    const handleScroll = () => {
      const { scrollLeft, scrollTop } = playoffTable;
      linesOverlay.style.left = `-${scrollLeft}px`;
      linesOverlay.style.top = `-${scrollTop}px`;
    };

    calculatePositions();
    window.addEventListener("resize", calculatePositions);
    playoffTable.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", calculatePositions);
      playoffTable.removeEventListener("scroll", handleScroll);
    };
  }, [data, lines]); // Add lines to the dependency array
  */
  const isUser = JSON.parse(localStorage.getItem('isUser'));




  // Batch 4.1: bracket match-date prefill. The no-bracket equivalent is the teamData effect below.
  // useEffect(() => {
  //   if (dataList?.matchStartDate) {
  //     const startDate = new Date(dataList?.matchStartDate);
  //     const timezoneOffset = startDate.getTimezoneOffset();
  //     startDate.setMinutes(startDate.getMinutes() - timezoneOffset);
  //     if (dataList?.matchStartDate === "0001-01-01T00:00:00" || dataList?.matchStartDate === null || dataList?.matchStartDate === "") {
  //
  //       setStartMatch();
  //     } else {
  //       setStartMatch(startDate);
  //     }
  //
  //   }
  // }, [dataList]);


  useEffect(() => {
    if (teamData[0]?.matchStartDate) {
      const startDate = new Date(teamData[0]?.matchStartDate);
      const timezoneOffset = startDate.getTimezoneOffset();
      startDate.setMinutes(startDate.getMinutes() - timezoneOffset);
      if (teamData[0]?.matchStartDate === "0001-01-01T00:00:00" || teamData[0]?.matchStartDate === null || teamData[0]?.matchStartDate === "") {
        // const dateItem = new Date();
        // setDateUpdate(dateItem);
      } else {
        setDateUpdate(startDate);
      }

    }
  }, [teamData]);



  // const handleShowDate = (list) => {
  //   setShowDate(true)
  //   setDataList(list)
  // }

  // function convertUTCToLocalTime(utcDateString) {
  //   const date = new Date(utcDateString);
  //   return date.toString(); // Or use date.toLocaleString() for better format
  // }
  const scoreNoBracketModelDate = () => {
    setNoBracketshowDate(true)
  }


  const localTime = dayjs(teamData[0]?.matchStartDate + "Z").format("MM/DD/YYYY hh:mm:ss A");

  // Batch 4.1: contest header derived from the bracket payload. The no-bracket header below
  // (the `…1` values, derived from teamData) is the one that renders now.
  // const tournamentNames = roundData?.map(item => item.tournamentName);
  // const tournamentStart = roundData?.map(item => dayjs(item?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));

  // const firstStartDate = tournamentStart[0]
  // const tournamentendDate = roundData?.map(item => dayjs(item?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));
  // const firstEndDate = tournamentendDate[0]
  // const firstTournamentName = tournamentNames[0];


  const tournamentNames1 = teamData?.map(item => item.tournamentName);
  const tournamentStart1 = teamData?.map(item => dayjs(item?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));
  const tournamentendDate1 = teamData?.map(item => dayjs(item?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));
  const firstStartDate1 = tournamentStart1[0]
  const firstEndDate1 = tournamentendDate1[0]
  const firstTournamentName1 = tournamentNames1[0];

  // #216: a contest has players once one of its lots has sold; until then its rows carry
  // hasPlayers false and the page shows the placeholder instead of the team list and editors.
  // Compared with false, not negated: a server from before the field omits it, and its contests
  // keep showing their list.
  const hasPlayers = teamData.length > 0 && teamData[0]?.hasPlayers !== false;

  // #223: why Publish Results is not available yet, or null. Checked again, on fresh rows, when
  // the button is pressed.
  const publishReason = publishBlocker(teamData, Date.now());

  return (
    <>

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group1" >
        <Sidebar data={dataSide} />
        <div className="testbracket">
          <div
            className={
              dataSide ? "dashboard-content full-contnet" : "dashboard-content"
            }
          >


            {/*
              Batch 4.1: the bracket header branch is commented out. roundData is now always
              empty, so only the no-bracket header below can render; the ternary is kept so the
              two branches stay side by side for whoever restores this.

              {roundData?.length > 0 ?
                <>

                  <h4 className="mb-3 text-dark text-breacket-heading">
                    Contest Name: <span className="text-primary text-name-tourna">{firstTournamentName}</span> Contest Start Date : <span className="text-primary text-name-tourna">{firstStartDate}</span>Contest End Date : <span className="text-primary text-name-tourna">{firstEndDate}</span>
                  </h4>

                </> :
            */}

              {/* #216: the contest's name and dates come from its team rows, which a contest has
                  from its first save - with players or without. Only a failed load has none. */}
              {teamData.length > 0 && (

                <h4 className="mb-3 text-dark">
                  Contest Name: <span className="me-5 text-primary">{firstTournamentName1}</span>Contest Start Date : <span className="me-5 text-primary">{firstStartDate1}</span>Contest End Date : <span className="me-5 text-primary">{firstEndDate1}</span>
                </h4>

              )}



            <div class="bracket  disable-image bg-white">

              {/*
                Batch 4.1 (#83 MG-009, #85 AD-009): the bracket Update Teams Score and
                Update Match Start Date modals. They are commented out in two blocks
                because the JSX comment already inside them would close this one early.
              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Update Teams Score</Modal.Title>
                </Modal.Header>
                <Modal.Body>




                  {
                    dataList?.leftTeamName == null ?

                      <Form.Group as={Row} className="" >
                        <Form.Label column sm="2" className='p-0'>

                          <Form.Control
                            required
                            type="number"
                            disabled
                            name="leftTeamScore"
                            value={dataList?.leftTeamScore == null ? 0 : dataList?.leftTeamScore}
                            maxLength={50}
                            onChange={handelScoreUpdate}

                          />
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control type="text" disabled value={dataList?.leftTeamName} />
                        </Col>

                      </Form.Group>



                      :
                      <Form.Group as={Row} className="" >
                        <Form.Label column sm="2" className='p-0'>

                          <Form.Control
                            required
                            type="number"
                            name="leftTeamScore"
                            value={dataList?.leftTeamScore == null ? 0 : dataList?.leftTeamScore}
                            maxLength={50}
                            onChange={handelScoreUpdate}

                          />
                        </Form.Label>
                        <Col sm="10">
                          <Form.Control type="text" value={dataList?.leftTeamName} />
                        </Col>

                      </Form.Group>
                  }
                  {
                    dataList?.rightTeamName == null ?
                      <Form.Group as={Row} className="" >
                        <Form.Label column sm="2" className='p-0'>

                          <Form.Control
                            required
                            type="number"
                            disabled
                            name="rightTeamScore"
                            value={dataList?.rightTeamScore == null ? 0 : dataList?.rightTeamScore}
                            maxLength={50}
                            onChange={handelScoreUpdate}

                          />

                        </Form.Label>
                        <Col sm="10">
                          <Form.Control type="text" disabled value={dataList?.rightTeamName} />
                        </Col>
                      </Form.Group> :
                      <Form.Group as={Row} className="" >
                        <Form.Label column sm="2" className='p-0'>

                          <Form.Control
                            required
                            type="number"
                            name="rightTeamScore"
                            value={dataList?.rightTeamScore == null ? 0 : dataList?.rightTeamScore}
                            maxLength={50}
                            onChange={handelScoreUpdate}

                          />

                        </Form.Label>
                        <Col sm="10">
                          <Form.Control type="text" value={dataList?.rightTeamName} />
                        </Col>
                      </Form.Group>
                  }


                  <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" checked={isChecked}
                      onChange={handleCheckboxChange} label="Match Completed" />
                  </Form.Group>

              */}
                  {/* <p>By Proceeding, you will not be able to update scores again.</p> */}
              {/*


                  <Button variant="success" onClick={handleScorecheck}>
                    Submit
                  </Button>





                </Modal.Body>
                <Modal.Footer>

                </Modal.Footer>
              </Modal>

              <Modal show={showDate} centered onHide={handleClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Update Match Start Date </Modal.Title>
                </Modal.Header>
                <Modal.Body>




                  <Form.Group as={Row} className="mb-3" >



                    <DatePicker
                      placeholder="Select Match start Date"
                      format="MM/dd/yyyy hh:mm:ss aa"
                      showMeridian
                      value={startMatch}
                      disabledDate={(date) => firstStartDate && dayjs(date).isBefore(firstStartDate, 'day')}

                      onChange={handelDate}
                      name="matchStartDate"
                      className='Auction-Date'
                    />
                  </Form.Group>
                  <Button variant="success" onClick={handleDateUpdate}>
                    Submit
                  </Button>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
              </Modal>
              */}

              {/* Batch 4.1: roundData is now always empty, so this is no longer a
                  ternary - the bracket branch below is commented out. */}
              {roundData.length === 0 && (<>

                <Card className='p-3'>
                  {/* #216: a contest without players used to show its teams with score 0 and
                      no explanation. Not until something has sold (hasPlayers). */}
                  {loading && teamData.length === 0 && <Loader center={false} size="md" className="my-4 text-center" />}
                  {!loading && loadError && (
                    <div className="winners-empty">
                      <icons.ExclamationTriangle className="winners-empty-icon" />
                      <p>{loadError}</p>
                    </div>
                  )}
                  {!loading && !loadError && !hasPlayers && (
                    <div className="winners-empty">
                      <icons.People className="winners-empty-icon" />
                      <p>
                        There are no players in this contest yet. Results will be available once
                        players are added in the auction.
                      </p>
                    </div>
                  )}
                  <Row>
                    {
                      hasPlayers ? <> <Col md="6">
                        <h5>Player List - <span className='text-danger'>The highest score will be the winner !</span></h5>

                      </Col>
                        <Col md="6" className="text-right">

                          <div className='dateMatachUpdate'>
                            <div className="date update">
                              {
                                teamData[0]?.matchStartDate === "0001-01-01T00:00:00"
                                  ? <p>Select Match Start Date</p>
                                  : localTime
                              }

                              {teamData[0]?.isCompleted == true ? <Button variant='success' disabled className='ms-3 placebid disable' onClick={() => scoreNoBracketModelDate(teamData[0])} ><icons.Pencil></icons.Pencil> </Button> : <Button variant='success' className='ms-3' onClick={() => scoreNoBracketModelDate(teamData[0])} ><icons.Pencil></icons.Pencil> </Button>
                              }
                            </div>
                          </div>
                          {/* <hr></hr> */}

                          {/* #213: one date modal for the contest. It used to be rendered once per
                              team, so opening it stacked a copy per team, all bound to one value.
                              #271: centred on the content area, clear of the contest header. */}
                          <Modal
                            show={noBracketshowDate}
                            onHide={handleNoBracketClose}
                            centered
                            dialogClassName={dataSide ? undefined : "modal-beside-sidebar"}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Update Match Start Date  </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>



                              <Form validated={validated}>
                                <Form.Group as={Row} className="mb-3" >
                                  <DatePicker
                                    placeholder="Select Match Start Date"
                                    format="MM/dd/yyyy hh:mm:ss aa"
                                    showMeridian
                                    disabledDate={(date) => firstStartDate1 && dayjs(date).isBefore(firstStartDate1)}
                                    value={dateUpdate}
                                    onChange={handelNoBracketDate}
                                    name="matchStartDate"
                                    className='Auction-Date'
                                    required
                                  />

                                  <Form.Control.Feedback type="invalid" style={{ display: dateValid ? 'none' : 'block' }}>
                                    Please select the match start date and time.
                                  </Form.Control.Feedback>
                                </Form.Group>

                                <Button variant="success" onClick={() => handleNoBracketDateUpdate(teamData[0]?.tournamentId)}>
                                  Submit
                                </Button>
                              </Form>


                            </Modal.Body>

                          </Modal>

                        </Col>
                      </>
                        : ""
                    }


                  </Row>



                  <ListGroup variant="flush" class="list-item-player">
                    {
                      hasPlayers && teamData.map((listItem) => <ListGroup.Item>
                        <div className='score-player-name'>

                          {/* #223: a team not scored yet has a null score, shown as a dash. */}
                          <h5> <span className='text-score-update'>{isScored(listItem) ? listItem.playerScore : "—"}  </span> {listItem?.playerName}  </h5>
                        </div>

                        <div className='score-date-edit'>
                          {
                            listItem?.isCompleted == true ? <Button variant='success' disabled className='ms-3 placebid disable' onClick={() => scoreNoBracketModel(listItem)} ><icons.Pencil></icons.Pencil></Button> : <Button variant='success' className='ms-3' onClick={() => scoreNoBracketModel(listItem)} ><icons.Pencil></icons.Pencil></Button>
                          }

                        </div>

                      </ListGroup.Item>)

                    }

                  </ListGroup>

                  {/* #223: publishing the results is one action for the contest, after every team
                      is scored. It was a "Match Completed" checkbox in the last team's score dialog
                      only, so a Manager who scored every team never completed the contest. */}
                  {hasPlayers && (
                    <div className="d-flex flex-wrap justify-content-end align-items-center gap-3 mt-3">
                      {isResultsPublished(teamData) ? (
                        <p className="mb-0 text-success">
                          <icons.CheckCircle className="me-2" />
                          Results published. The scores are final.
                        </p>
                      ) : (
                        <>
                          {publishReason && <p className="mb-0 text-muted small">{publishReason}</p>}
                          <Button
                            variant="success"
                            disabled={!!publishReason}
                            onClick={handlePublishOpen}
                          >
                            Publish Results
                          </Button>
                        </>
                      )}
                    </div>
                  )}

                  <Modal show={!!publishRows} onHide={handlePublishClose} centered>
                    <Modal.Header closeButton={!publishing}>
                      <Modal.Title>Publish Results</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <p>
                        These are the final standings. Once published, the scores can no longer be
                        changed, and the prize pool is paid out by them.
                      </p>
                      <ListGroup as="ol" numbered>
                        {rankTeams(publishRows).map((row) => (
                          <ListGroup.Item as="li" key={row.matchId} className="d-flex justify-content-between align-items-center">
                            <span className="ms-2 me-auto">{row.playerName}</span>
                            <strong>{row.playerScore}</strong>
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" disabled={publishing} onClick={handlePublishClose}>
                        Cancel
                      </Button>
                      <Button variant="success" disabled={publishing} onClick={handlePublishConfirm}>
                        {publishing ? "Publishing..." : "Publish Results"}
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  {/* #213: one score modal, for the team whose pencil was clicked (selectedListItem).
                      It used to be rendered once per team, so every copy opened at once with the
                      same value. #271: centred on the content area beside the open sidebar, not
                      at the top of the window, where it covered the contest's name and dates. */}
                  <Modal
                    show={noBracketshow && !!selectedListItem}
                    onHide={handleNoBracketClose}
                    centered
                    dialogClassName={dataSide ? undefined : "modal-beside-sidebar"}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Update Teams Score</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form noValidate>
                        <Form.Group controlId="validationCustom01">
                          <Form.Control
                            required
                            type="number"
                            min={0}
                            step={1}
                            maxLength={50}
                            name="rightTeamScore"
                            value={scoreNoBracket}
                            isInvalid={scoreInvalid}
                            onChange={handelNoBracketScoreUpdate}
                          />
                          <Form.Control.Feedback type="invalid">
                            {SCORE_INVALID_MESSAGE}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Button className="mt-3" variant="success" onClick={handleNoBracketScorecheck}>
                          Submit
                        </Button>
                      </Form>


                    </Modal.Body>

                  </Modal>
                </Card>


              </>)}

              {/*
                Batch 4.1 (#82/#83/#84/#85): the whole bracket view - the playoff table,
                the shuffle controls and the Score button. Commented out in two blocks
                for the same reason as the modals above. Restore together with the
                geometry helpers near the top of this file.
                <>




                  <h5 className="p-3 "><span className="text-danger">*</span> You can Shuffle teams using <button><icons.Shuffle className='suffle-icon' /></button> icon and hit <button><icons.Save2 className='save-icon' /> </button> icon after completion</h5>
                  <div className="playoff-table">

                    <div className="playoff-table-content">

                      {
                        Object.keys(data).map((roundKey, roundIndex) => (
                          <div key={roundKey} className="playoff-table-tour">
                            {data[roundKey].map((pair, index) => {
                              const matchDetails = roundData.sort((a, b) => b.matchLevel - a.matchLevel).find((match) => (match.leftTeamId === pair[0] && (match.rightTeamId === pair[1] || match.rightTeamId === 0)) || (match.rightTeamId === pair[1] && match.leftTeamId === 0));

                              const localTime = convertUTCToLocalTime(matchDetails?.matchStartDate + "Z");
                              const dayjsDate = dayjs(localTime);
                              const formattedDate = dayjsDate.format("MM/DD/YYYY");
                              const timePart = dayjsDate.format("hh:mm:ss A");
                              return (
                                <>
                                  <div
                                    key={index}
                                    id={`.round${roundIndex + 1}match${index + 1}`}
                                    className={`playoff-table-group round${roundIndex + 1}match${index + 1}`}
                                  >

                                    <div className={`playoff-table-pair playoff-table-pair-style ${!pair[0] && !pair[1] ? "playoff-table-pair--empty" : ""}`}>
                                      {
                                        matchDetails?.matchStartDate ? (
                                          <div className="dateUpdate">
                                            {matchDetails.matchStartDate === "0001-01-01T00:00:00" ? (
                                              <div>
                                                Select Match Start Date
                                                {!matchDetails.isCompleted && matchDetails.createdBy === isUser?.userId && (
                                                  <button
                                                    className="saveDate"
                                                    onClick={() => handleShowDate(matchDetails)}
                                                  >
                                                    <icons.PencilSquare className="editpencil" />
                                                  </button>
                                                )}
                                              </div>
                                            ) : (
                                              <span>
                                                {dayjs(matchDetails.matchStartDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}
                                                {!matchDetails.isCompleted && matchDetails.createdBy === isUser?.userId && (
                                                  <button
                                                    className="saveDate"
                                                    onClick={() => handleShowDate(matchDetails)}
                                                  >
                                                    <icons.PencilSquare className="editpencil" />
                                                  </button>
                                                )}
                                              </span>
                                            )}
                                          </div>
                                        ) : ""
                                      }

                                      <div className="playoff-table-left-player">
                                        {
                                          matchDetails?.leftTeamName ? <span className='back-count'>
                                            <p>{matchDetails?.leftTeamScore}</p>
                                          </span> : <span className='back-count opictity'>
                                            <p>{matchDetails?.leftTeamScore}</p>
                                          </span>
                                        }

                                        {
                                          editModeByIndex === matchDetails?.leftTeamId ? (
                                            <select className="selectbox-suff" onChange={handelOnChange}>
                                              <option>Select </option>
                                              {roundData?.map((itemList, i) => {
                                                return (
                                                  <>
                                                    {
                                                      itemList.leftTeamId === 0 && itemList.rightTeamId === 0 ? null : (
                                                        <>
                                                          {itemList.leftTeamId !== 0 && (
                                                            <option value={`${itemList.matchId}, ${itemList.leftTeamId}`}>
                                                              {itemList.leftTeamName}
                                                            </option>
                                                          )}
                                                          {itemList.rightTeamId !== 0 && (
                                                            <option value={`${itemList.matchId}, ${itemList.rightTeamId}`}>
                                                              {itemList.rightTeamName}
                                                            </option>
                                                          )}
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )

                                              })}
                                            </select>
                                          ) : (
                                            <>
                                              {
                                                matchDetails?.leftTeamId ? <span className='team-list-name'>{matchDetails?.leftTeamName} </span> : <p className="tbdText">TBD</p>
                                              }

                                              {
                                                matchDetails?.winnerTeamId === matchDetails?.leftTeamId && matchDetails?.isCompleted === true ? <img src="/image/trophy1.png" className="me-2 suffle1"></img> : ""
                                              }
                                            </>
                                          )

                                        }

                                        {
                                          editModeByIndex === matchDetails?.leftTeamId ? (<>
                                            <button onClick={handleSaveClick}><icons.Save2 className='save-icon' />  </button>
                                            <button ><icons.XLg onClick={closebtn} /></button></>
                                          ) : (
                                            <>
              */}
                                              {/* {
                                              matchDetails?.leftTeamId ? matchDetails?.createdBy !== isUser?.userId ? <button disabled className='suffle disable ms-2' onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}><icons.Shuffle className='suffle-icon' /> </button> : <button className="ms-2 suffle" onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}><icons.Shuffle className='suffle-icon' /> </button> : ""
                                            } */}
              {/*

                                              {
                                              matchDetails?.winnerTeamId === matchDetails?.leftTeamId || matchDetails?.isCompleted === true ? null : (
                                                matchDetails?.leftTeamName ? (
                                                  matchDetails?.createdBy !== isUser?.userId ? (
                                                    <button disabled className='suffle disable ms-2' onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    
                                                    </button>
                                                  ) : (
                                                    <button className="ms-2 suffle" onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    </button>
                                                  )
                                                ) : null
                                              )
                                            }

                                            

                                            </>

                                          )

                                        }
                                      </div>
                                      <div className="playoff-table-right-player">
                                        {
                                          matchDetails?.rightTeamName ?
                                            <span className='back-count1'>
                                              <p>{matchDetails?.rightTeamScore}</p>
                                            </span> : <span className='back-count opictity'>
                                              <p>{matchDetails?.rightTeamScore}</p>
                                            </span>
                                        }
                                        {
                                          editModeByIndex === matchDetails?.rightTeamId ? (
                                            <select className="selectbox-suff" onChange={handelOnChange}>
                                              <option>Select </option>
                                              {roundData?.map((itemList, i) => {
                                                return (
                                                  <>
                                                    {
                                                      itemList.leftTeamId === 0 && itemList.rightTeamId === 0 ? null : (
                                                        <>
                                                          {itemList.leftTeamId !== 0 && (
                                                            <option value={`${itemList.matchId}, ${itemList.leftTeamId}`}>
                                                              {itemList.leftTeamName}
                                                            </option>
                                                          )}
                                                          {itemList.rightTeamId !== 0 && (
                                                            <option value={`${itemList.matchId}, ${itemList.rightTeamId}`}>
                                                              {itemList.rightTeamName}
                                                            </option>
                                                          )}
                                                        </>
                                                      )
                                                    }
                                                  </>
                                                )

                                              })}
                                            </select>
                                          ) : (
                                            <>

                                              {
                                                matchDetails?.rightTeamName ? <span className='team-list-name'>{matchDetails?.rightTeamName}

                                                </span> : <p className="tbdText">TBD</p>
                                              }
                                              {
                                                matchDetails?.winnerTeamId === matchDetails?.rightTeamId && matchDetails?.isCompleted === true ? <img src="/image/trophy1.png" className="me-2 suffle1"></img> : ""
                                              }
                                            </>
                                          )

                                        }


                                        {
                                          editModeByIndex === matchDetails?.rightTeamId ? (<>
                                            <button onClick={handleSaveClick}><icons.Save2 className='save-icon' /> </button>
                                            <button ><icons.XLg onClick={closebtn} /></button></>
                                          ) : (
                                            <>
                                              {
                                              matchDetails?.winnerTeamId === matchDetails?.rightTeamId || matchDetails?.isCompleted === true ? null : (
                                                matchDetails?.rightTeamName ? (
                                                  matchDetails?.createdBy !== isUser?.userId ? (
                                                    <button disabled className='suffle disable ms-2' onClick={() => handleEditClickTeam(matchDetails.rightTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    </button>
                                                  ) : (
                                                    <button className="ms-2 suffle" onClick={() => handleEditClickTeam(matchDetails.rightTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    </button>
                                                  )
                                                ) : null
                                              )
                                            }

                                           
                                            </>

                                          )

                                        }
                                      </div>

                                      {
                                        matchDetails?.isCompleted === false && matchDetails?.createdBy === isUser?.userId ? (
                                          <button className='saveScoreBtn' disabled={!matchDetails?.leftTeamName || !matchDetails?.rightTeamName} onClick={() => handleShow(matchDetails)}>Score </button>
                                        ) : (
                                          <button className='saveScoreBtn disable' disabled onClick={() => handleShow(matchDetails)}>Score</button>
                                        )
                                      }
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        ))
                      }        <svg className="lines-overlay">
                        {lines.map((line, index) => (
                          <line
                            key={index}
                            x1={line.x1}
                            y1={line.y1}
                            x2={line.x2}
                            y2={line.y2}
                            stroke="black"
                          />
                        ))}
                      </svg>
                    </div>
                  </div>
                </>)}
              */}
            </div>

          </div>
          {/*
            Batch 4.1: `data` was the bracket geometry object built by populateTree, which is now
            commented out. It was always truthy, so this always resolved to "footer".
            <div className={data ? "footer" : "footer-content"}>
          */}
          <div className="footer">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};
